import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

const leasingExpensesReducer = (state = initialState.currentOffer.leasingExpenses, action) => {
  switch (action.type) {
    case actionTypes.LOAD_LEASING_EXPENSES_STARTED: {
      return {
        ...state,
        loading: true
      };
    }
    case actionTypes.LOAD_LEASING_EXPENSES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }
    case actionTypes.LOAD_LEASING_EXPENSES_FAILED: {
      return {
        ...state
      };
    }

    case actionTypes.LEASING_EXPENSES_UPDATED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    case eventTypes.OFFER_LEASING_EXPENSES_INVALIDATED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    default:
      return state;
  }
};
export default leasingExpensesReducer;
